import React from "react";
import { Tag } from "antd";
import { UserOutlined } from "@ant-design/icons";

const ParticipantCard = ({ name, phoneNumbers, roles, isReceiver, isCaller }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-3 flex flex-row items-center justify-between w-full shadow-sm">
      <div className="flex items-center gap-3">
        <div
          className={`w-10 h-10 ${
            isReceiver ? "bg-blue-100" : "bg-cyan-100"
          } rounded-full flex items-center justify-center`}
        >
          <UserOutlined className={`${isReceiver ? "text-blue-500" : "text-cyan-500"} text-lg`} />
        </div>
        <div className="flex flex-col">
          <span className="font-medium text-gray-900 text-sm">{name}</span>
          {(() => {
            const extension = phoneNumbers.get("extension");
            const phone = phoneNumbers.get("phone");

            if (extension && phone) {
              // Both extension and phone number exist
              return (
                <div className="text-xs text-gray-500">
                  {extension} | {phone}
                </div>
              );
            }
            if (extension) {
              // Only extension exists
              return <div className="text-xs text-gray-500">Extension: {extension}</div>;
            }
            if (phone) {
              // Only phone number exists
              return <div className="text-xs text-gray-500">{phone}</div>;
            }
            return null;
          })()}
          {/* Display combined roles */}
          {roles.size > 0 && (
            <div className="text-xs text-gray-400">{Array.from(roles).join(", ")}</div>
          )}
        </div>
      </div>
      <div className="flex gap-1">
        {isReceiver && (
          <Tag color="blue" className="rounded-md text-xs">
            Receiver
          </Tag>
        )}
        {isCaller && (
          <Tag color="cyan" className="rounded-md text-xs">
            Caller
          </Tag>
        )}
      </div>
    </div>
  );
};

export default ParticipantCard;
